<template>
    <v-input
        ref="input"
        :rules="rules"
        :disabled="disabled"
        :readonly="readonly"
        :hide-details="hideDetails"
        :error-messages="errorMessages"
        :label="label"
        :hint="hint"
        :class="`text-field ${required
            ? '--required'
            : ''
        } ${disabled ? 'input--disabled': ''}`"
        :style="{ maxWidth: maxWidth }"
        v-model="value"
        light
        @mousedown="toggleIframesInteraction(false)"
        @mouseup="toggleIframesInteraction(true)"
    >
        <the-mask
            v-if="mask"
            :autocomplete="type === 'password' ? 'off' : 'on'"
            :type="_type"
            :placeholder="placeholder"
            :value="value"
            :maxlength="maxlength"
            :mask="mask"

            @input="e => { $emit('input', e) }"

            @change.native="e => { $emit('change', e) }"
            @focus.native="e => { $emit('focus', e) }"
            @blur.native="e => {
                $emit('blur', e)
                toggleIframesInteraction(true)
            }"
        />
        <input
            v-else
            :autocomplete="type === 'password' ? 'off' : 'on'"
            :type="_type"
            :placeholder="placeholder"
            :value="value"
            :maxlength="maxlength"

            @input="e => { $emit('input', e.target.value) }"

            @change="e => { $emit('change', e) }"
            @focus="e => { $emit('focus', e) }"
            @blur="e => {
                $emit('blur', e)
                toggleIframesInteraction(true)
            }"
        />
        <i
            v-if="type === 'password'"
            :class="`v-icon bexsicon theme--light ${_type === 'password'
                ?  'bexsicon-eye'
                : 'bexsicon-eye-blocked'}`"
            @click="showPassword = !showPassword"
        ></i>

        <i :class="`v-icon bexsicon theme--light text-field__append-icon ${appendIcon}`"></i>

    </v-input>
</template>

<script>
import { IFRAME } from '../../utils/constants'
export default {
    name: 'text-field',
    props: {
        value: { required: true },
        rules: Array,
        disabled: Boolean,
        readonly: Boolean,
        maxlength: { type: String, default: '524288'},
        maxWidth: { type: String },
        errorMessages: String,
        appendIcon: String,
        label: String,
        hint: String,
        mask: { type: String | Object, default: null},
        'hideDetails': Boolean,
        required: Boolean,
        placeholder: String,
        type: String,
    },
    computed:{
        _type(){
            return this.type === 'password' && this.showPassword ? 'text' : this.type
        }
    },
    data() {
        return {
            showPassword: false
        }
    },
    methods: {
        toggleIframesInteraction(canInteract){
            this.$store.commit(IFRAME.SET_INTERACTION, canInteract)
        },
        validate(){
            return this.$refs.input.validate()
        },
    }
}
</script>

<style lang="scss" >

    .text-field {
        margin-top: 21px;
        transition: .3s cubic-bezier(.25,.8,.5,1);

        &__append-icon {
            font-size: 16px !important;
        }

        .v-label {
            position: absolute !important;
            top: -25px !important;
            font-size: 14px !important;
        }

        input {
            width: 100%;
            transition: inherit;

            &::-webkit-input-placeholder {
                font-style: italic;
            }
            &:-moz-placeholder {
            font-style: italic;
            }
            &::-moz-placeholder {
            font-style: italic;
            }
            &:-ms-input-placeholder {
            font-style: italic;
            }
        }

        .v-input__slot {
            padding: 3.25px .5em;
            border: 1px solid #dcdcdc;
            border-radius: 5px;
            transition: inherit;
        }

    }

</style>



// WEBPACK FOOTER //
// ./src/components/fields/TextField.vue